const GUEST_URLS = [
  '/login',
  '/logout',
  '/signup',
  '/user/resetPassword',
  '/lookbooks',
  '/contact',
  '/tradeshows',
  '/admin/login',
  '/p/'
]

export default defineNuxtRouteMiddleware(async (to) => {
  // const nuxtApp = useNuxtApp()
  // if (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) return

  const toPath = to.path?.toLowerCase()
  if (to.path.startsWith('/error')) return

  //const runtimeConfig = useRuntimeConfig()
  const appConfigStore = useAppConfigStore()
  const appConfig = appConfigStore.appConfig!
  const storeLeftNav = useLeftNavStore()
  const userDataCookie = useCookie(appConfig.public.CLIENT_USER_COOKIE)
  const { setUserData, userData } = useUserStore()
  setUserData(userDataCookie.value)

  //console.log('> Middleware check guest url ', toPath, GUEST_URLS)
  if (GUEST_URLS.find((url) => !!toPath && toPath.startsWith(url.toLowerCase()))) return

  const hasAccess = storeLeftNav.hasAccessToMenu(to.path, userData)
  //console.warn(`hasAccess to Page ${to.path}: ${hasAccess}`)
  if (!hasAccess) {
    showError({
      statusCode: 403,
      statusMessage: 'Has no access to Page.'
    })
    return abortNavigation()
  }

  const accessToken = useCookie(appConfig.public.CLIENT_ACCESS_TOKEN_COOKIE)
  //console.log('> Middleware Auth token: ', toPath, accessToken.value)
  if (!accessToken.value && toPath !== '/login') {
    return navigateTo('/login')
  }
})
